import { render } from "./FavButon.vue?vue&type=template&id=437e344a"
import script from "./FavButon.vue?vue&type=script&lang=js"
export * from "./FavButon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__